module.exports = __webpack_public_path__ + "img/confetti_1b.dc71c696.svg";